import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_PAGES = {
  hero: {
    eyebrow: "Estate 2026 — con Alessandro",
    title_line1: "Summer Heels",
    title_italic: "Experience",
    description:
      "Workshop di Heels Dance per chi desidera mettersi in gioco, scoprire nuove potenzialità e approfondire il proprio percorso. Tecnica, attitude e presenza scenica in un'estate di crescita.",
    cta_primary: "Scopri i Workshop",
    cta_secondary: "Iscriviti ora",
    logo_url:
      "https://customer-assets.emergentagent.com/job_heels-dance-journey/artifacts/qnhcpxfy_ChatGPT%20Image%2017%20giu%202026%2C%2020_43_04.png",
  },
  workshops: {
    eyebrow: "I Workshop",
    heading_line1: "Scopri i workshop",
    heading_italic: "più adatti a te",
    description:
      "Tre formati distinti, ognuno declinato su tre livelli. Clicca su un banner per esplorare contenuti, date e prezzi.",
  },
  reviews: {
    eyebrow: "Voci dal palco",
    heading_line1: "Cosa dicono",
    heading_italic: "le mie allieve",
    description: "",
  },
  footer: {
    brand_part1: "Summer",
    brand_part2: "Heels",
    brand_part3: "Experience",
    copyright: "© 2026 · Con Alessandro",
    email: "mantelheelsexperience@gmail.com",
    instagram_url: "https://www.instagram.com/mantelheelsexperience/",
  },
};

/**
 * Fetch the editable page content from the backend.
 * Returns DEFAULT_PAGES until the network call resolves so the UI never flashes empty.
 */
export const usePagesContent = () => {
  const [pages, setPages] = useState(DEFAULT_PAGES);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/pages`)
      .then((res) => {
        if (!cancelled && res.data) {
          setPages({
            hero: { ...DEFAULT_PAGES.hero, ...(res.data.hero || {}) },
            workshops: { ...DEFAULT_PAGES.workshops, ...(res.data.workshops || {}) },
            reviews: { ...DEFAULT_PAGES.reviews, ...(res.data.reviews || {}) },
            footer: { ...DEFAULT_PAGES.footer, ...(res.data.footer || {}) },
          });
        }
      })
      .catch(() => {
        /* silently keep defaults */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return pages;
};

export { DEFAULT_PAGES };
